import { CashdroLevels } from '@pos/interfaces/cashdro-specific-responses-interface';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-cashdro-levels-table',
  components: {},
})
export default class CashdroLevelsTable extends Vue {
  @Prop({ type: Array, default: [] }) readonly levels: CashdroLevels[];

  /* DATA for check cashdro status modal */

  // COMPUTED:
  getAcceptedLevels() {
    return this.levels.filter(level => parseInt(level.Destination) !== 0);
  }
  getLevelType(level: CashdroLevels) {
    let stringType = '';
    if (level.Type) {
      switch (level.Type) {
        case '1':
          stringType = this.$t('payment_terminals.coin') as string;
          break;
        case '2':
          stringType = this.$t('payment_terminals.bill') as string;
          break;
        case '3':
          stringType = this.$t('payment_terminals.coins-cassette') as string;
          break;
        case '4':
          stringType = this.$t('payment_terminals.bills-cassette') as string;
          break;
        case '5':
          stringType = this.$t('payment_terminals.coins-recycler') as string;
          break;
      }
    }
    return stringType ? stringType : level.Type;
  }

  getLevelState(level: CashdroLevels) {
    let stringState = '';
    if (level.State) {
      switch (level.State) {
        case '-1':
          stringState = this.$t('payment_terminals.correct-level') as string;
          break;
        case '0':
          stringState = this.$t('payment_terminals.critical-level') as string;
          break;
        case '1':
          stringState = this.$t('payment_terminals.inhibition-level') as string;
          break;
        case '2':
          stringState = this.$t('payment_terminals.level-below-minimun') as string;
          break;
        case '3':
          stringState = this.$t('payment_terminals.level-above-maximun') as string;
          break;
        case '5':
          stringState = this.$t('payment_terminals.level-zero') as string;
          break;
      }
    }
    return stringState ? stringState : level.State;
  }

  getLevelValue(level: CashdroLevels) {
    return parseInt(level.Value) / 100 + '€';
  }
  getDepositlevel(level: CashdroLevels) {
    return parseInt(level.DepositLevel);
  }
  getMinlevel(level: CashdroLevels) {
    return parseInt(level.MinLevel);
  }
  getMaxlevel(level: CashdroLevels) {
    return parseInt(level.MaxLevel);
  }
  getMaxPiecesExchange(level: CashdroLevels) {
    return parseInt(level.MaxPiecesExchange) / 100 + '€';
  }
  levelIsWorng(level: CashdroLevels) {
    return level.State !== '-1';
  }

  getCurrentLevelRecycler(level: CashdroLevels) {
    return (parseInt(level.LevelRecycler) * parseInt(level.Value)) / 100;
  }

  getCurrentUnitLevel(level: CashdroLevels) {
    return parseInt(level.LevelRecycler);
  }

  getTotalCurrentLevel(): number {
    let total = 0;
    this.levels.forEach(level => {
      total += this.getCurrentLevelRecycler(level);
    });

    return total;
  }
}
